import { defineStore } from 'pinia';
import { ProductOut, ProductFamily } from '@/client/types';
import { ProductApiClient, ProductFamilyApiClient } from '@/client/requests';

export const useProductStore = defineStore('product', {
  state: () => ({
    productList: [] as ProductOut[],
    productFamilyList: [] as ProductFamily[],
  }),
  getters: {
    
  },
  actions: {
    /**
     * Fetches the list of active products from the API and updates the `productList` property.
     *
     * @returns {Promise<void>} A promise that resolves when the products have been fetched and stored.
     */
    async fetchProducts() {
      const apiClient: ProductApiClient = new ProductApiClient();
      const products: ProductOut[] = await apiClient.getActiveProducts();
      this.productList = products;
    },

    /**
     * Fetches a list of products by the serial number prefix (family code) from the API and updates the `productList` property.
     *
     * @param {string} serialPrefix - The prefix of the serial number (family code) to filter products by.
     * @returns {Promise<void>} A promise that resolves when the products have been fetched and stored.
     */
    async fetchProductsBySerialPrefix(serialPrefix: string) {
      const apiClient: ProductApiClient = new ProductApiClient();
      const products: ProductOut[] = await apiClient.getProductsByFamily(serialPrefix);
      this.productList = products;
    },

    /**
     * Fetches the list of product families from the API and updates the `productFamilyList` property.
     *
     * @returns {Promise<void>} A promise that resolves when the product families have been fetched and stored.
     */
    async fetchProductFamilies() {
      const apiClient: ProductFamilyApiClient = new ProductFamilyApiClient();
      const productFamilyPage = await apiClient.getByPage(1, 100);
      const productFamilies: ProductFamily[] = productFamilyPage.items;
      this.productFamilyList = productFamilies;
    },
  },
});